<template>
    <standard-frame :sub-title="displayItem.title" :sub-content="displayItem.content"/>
</template>

<script>
  import StandardFrame from './StandardFrame'

  export default {
    name: 'TeamDetail',
    components: {StandardFrame},
    data() {
      return {
        displayItem: {
          title: '我们的团队', content: `<p>我们的团队汇聚了旅游产业的精英:组团采购商总经理、地接采购商总经理、团队订房中心总经理、酒店互联网智能应用专家，从业经历均10年以上，对行业有着专家级了解！</p>
                                                   <p>旅游产业互联网机遇的到来，我们将解决酒店和采购商之间团房信息不对称的问题，去除中间环节、极速撮合、提高利润，为旅游产业提供更多的价值！</p>`
        }
      }
    }
  }
</script>
